import '../../scss/themes/platnik.scss';
import 'efile-ui/dist/base';

import '../shared/footer';
import '../shared/common';

window.PACKAGE_ARGS = {
	useScroll: false,
};

$(document).ready(function () {
/*
	const fonts = ['brands', 'light', 'solid', 'fontawesome'];

	fonts.forEach((font) => {
		const href = $('#cms_pagehead').length ? `/szablony/e-pity/1/images/vendor/fontawesome-pro/css/${font}.min.css` : `/cms/img/1/vendor/fontawesome-pro/css/${font}.min.css`;

		const $link = $('<link />', {
			rel: 'stylesheet',
			type: 'text/css',
			href
		});

		$('head').append($link);
	});

*/
});


SCRIPTS.split(',').forEach((script) => {
	switch (script) {

		case 'VIDEO':
			import('../shared/video').then(() => {}).catch((error) => {
        console.log('Shared Video load failed!');
        console.log(error);
			});
			break;

		case 'HELP':
			import('../shared/help').then(() => {}).catch((error) => {
        console.log('Shared Help load failed!');
        console.log(error);
			});
			break;

		default:
			return null;
	}
});

if($('#control_suwak').length) {
	import('./modules/cennik').then(() => {});
}

if ($('.video-player').length) {
  import('../shared/video').then(() => {});
}

if ($('[rel*="lightbox"]').length) {
  import('../shared/lightbox').then(() => {});
}

if ($('.collapsed').length) {
	import('efile-ui/dist/collapse').then(() => {});
}